import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../../../services/modal.service';

@Component({
  selector: 'app-delete-payment-dialog',
  templateUrl: './delete-payment-dialog.component.html',
  styleUrls: ['./delete-payment-dialog.component.scss'],
})
export class DeletePaymentDialogComponent {
  @Input() deleteGroup!: any[];
  @Output() deleteEvent: EventEmitter<void> = new EventEmitter<void>();
  protected readonly close = close;

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.isModalOpen$.next(false);
  }

  deleteCash() {
    this.deleteEvent.emit();
  }
}
